import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getTemplates as getTemplatesSdk,
  getTemplate as getTemplateSdk,
  getTemplateConectores as getTemplateConectoresSdk,
  postTemplate as postTemplateSdk,
  putTemplate as putTemplateSdk,
  deleteTemplateConector as deleteTemplateConectorSdk,
  getTemplatesGrupos as getTemplatesGruposSdk,
} from '@sdk/Conectores/Templates/Templates';

//Action Types
export const Types = {
  GET_TEMPLATES: 'GET_TEMPLATES',
  GET_TEMPLATES_SUCCESS: 'GET_TEMPLATES_SUCCESS',
  GET_TEMPLATES_ERROR: 'GET_TEMPLATES_ERROR',

  GET_TEMPLATE: 'GET_TEMPLATE',
  GET_TEMPLATE_SUCCESS: 'GET_TEMPLATE_SUCCESS',
  GET_TEMPLATE_ERROR: 'GET_TEMPLATE_ERROR',

  GET_TEMPLATE_CONECTORES: 'GET_TEMPLATE_CONECTORES',
  GET_TEMPLATE_CONECTORES_SUCCESS: 'GET_TEMPLATE_CONECTORES_SUCCESS',
  GET_TEMPLATE_CONECTORES_ERROR: 'GET_TEMPLATE_CONECTORES_ERROR',

  GET_TEMPLATES_GRUPOS: 'GET_TEMPLATES_GRUPOS',
  GET_TEMPLATES_GRUPOS_SUCCESS: 'GET_TEMPLATES_GRUPOS_SUCCESS',
  GET_TEMPLATES_GRUPOS_ERROR: 'GET_TEMPLATES_GRUPOS_ERROR',

  POST_TEMPLATE: 'POST_TEMPLATE',
  POST_TEMPLATE_SUCCESS: 'POST_TEMPLATE_SUCCESS',
  POST_TEMPLATE_ERROR: 'POST_TEMPLATE_ERROR',

  PUT_TEMPLATE: 'PUT_TEMPLATE',
  PUT_TEMPLATE_SUCCESS: 'PUT_TEMPLATE_SUCCESS',
  PUT_TEMPLATE_ERROR: 'PUT_TEMPLATE_ERROR',

  DELETE_TEMPLATE_CONECTORES: 'DELETE_TEMPLATE_CONECTORES',
  DELETE_TEMPLATE_CONECTORES_SUCCESS: 'DELETE_TEMPLATE_CONECTORES_SUCCESS',
  DELETE_TEMPLATE_CONECTORES_ERROR: 'DELETE_TEMPLATE_CONECTORES_ERROR',

  RESET_TEMPLATES: 'RESET_TEMPLATES',
};

//Action Creators
export const getTemplates = (idGrupo) => ({ type: Types.GET_TEMPLATES, idGrupo });
export const getTemplatesSuccess = (data) => ({ type: Types.GET_TEMPLATES_SUCCESS, data });
export const getTemplatesError = (error) => ({ type: Types.GET_TEMPLATES_ERROR, error });

export const getTemplate = (id) => ({ type: Types.GET_TEMPLATE, id });
export const getTemplateSuccess = (data) => ({ type: Types.GET_TEMPLATE_SUCCESS, data });
export const getTemplateError = (error) => ({ type: Types.GET_TEMPLATE_ERROR, error });

export const getTemplateConectores = (id) => ({ type: Types.GET_TEMPLATE_CONECTORES, id });
export const getTemplateConectoresSuccess = (data) => ({ type: Types.GET_TEMPLATE_CONECTORES_SUCCESS, data });
export const getTemplateConectoresError = (error) => ({ type: Types.GET_TEMPLATE_CONECTORES_ERROR, error });

export const getTemplatesGrupos = () => ({ type: Types.GET_TEMPLATES_GRUPOS });
export const getTemplatesGruposSuccess = (data) => ({ type: Types.GET_TEMPLATES_GRUPOS_SUCCESS, data });
export const getTemplatesGruposError = (error) => ({ type: Types.GET_TEMPLATES_GRUPOS_ERROR, error });

export const postTemplate = (data) => ({ type: Types.POST_TEMPLATE, data });
export const postTemplateSuccess = () => ({ type: Types.POST_TEMPLATE_SUCCESS });
export const postTemplateError = (error) => ({ type: Types.POST_TEMPLATE_ERROR, error });

export const putTemplate = (data) => ({ type: Types.PUT_TEMPLATE, data });
export const putTemplateSuccess = () => ({ type: Types.PUT_TEMPLATE_SUCCESS });
export const putTemplateError = (error) => ({ type: Types.PUT_TEMPLATE_ERROR, error });

export const deleteTemplateConector = (idConfiguracao, idFonteDado) => ({
  type: Types.DELETE_TEMPLATE_CONECTORES,
  idConfiguracao,
  idFonteDado,
});
export const deleteTemplateConectorSuccess = () => ({ type: Types.DELETE_TEMPLATE_CONECTORES_SUCCESS });
export const deleteTemplateConectorError = (error) => ({ type: Types.DELETE_TEMPLATE_CONECTORES_ERROR, error });

export const reset = () => ({ type: Types.RESET_TEMPLATES });

//saga
function* fetchGetTemplates(action) {
  try {
    const templates = yield call(getTemplatesSdk, action.idGrupo);
    yield put(getTemplatesSuccess(templates));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTemplatesError(err));
  }
}

function* fetchGetTemplate(action) {
  try {
    const template = yield call(getTemplateSdk, action.id);
    yield put(getTemplateSuccess(template));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTemplateError(err));
  }
}

function* fetchGetTemplateConectores(action) {
  try {
    const templateConectores = yield call(getTemplateConectoresSdk, action.id);
    yield put(getTemplateConectoresSuccess(templateConectores));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTemplateConectoresError(err));
  }
}

function* fetchGetTemplatesGrupos(action) {
  try {
    const templatesGrupos = yield call(getTemplatesGruposSdk);
    yield put(getTemplatesGruposSuccess(templatesGrupos));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTemplatesGruposError(err));
  }
}

function* fetchPostTemplate(action) {
  try {
    yield call(postTemplateSdk, action.data);
    yield put(postTemplateSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postTemplateError(err));
  }
}

function* fetchPutTemplate(action) {
  try {
    yield call(putTemplateSdk, action.data);
    yield put(putTemplateSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putTemplateError(err));
  }
}

function* fetchDeleteTemplateConector(action) {
  try {
    yield call(deleteTemplateConectorSdk, action.idConfiguracao, action.idFonteDado);
    yield put(deleteTemplateConectorSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(deleteTemplateConectorError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_TEMPLATES, fetchGetTemplates),
  takeLatest(Types.GET_TEMPLATE, fetchGetTemplate),
  takeLatest(Types.GET_TEMPLATE_CONECTORES, fetchGetTemplateConectores),
  takeLatest(Types.GET_TEMPLATES_GRUPOS, fetchGetTemplatesGrupos),
  takeLatest(Types.POST_TEMPLATE, fetchPostTemplate),
  takeLatest(Types.PUT_TEMPLATE, fetchPutTemplate),
  takeLatest(Types.DELETE_TEMPLATE_CONECTORES, fetchDeleteTemplateConector),
];

// Reducer
const initialState = Map({
  templates: List(),
  template: {},
  templateConectores: List(),
  templatesGrupos: List(),

  loadingTemplates: false,
  successTemplates: false,
  errorTemplates: false,

  loadingTemplate: false,
  successTemplate: false,
  errorTemplate: false,

  loadingTemplateConectores: false,
  successTemplateConectores: false,
  errorTemplateConectores: false,

  loadingTemplatesGrupos: false,
  successTemplatesGrupos: false,
  errorTemplatesGrupos: false,

  postingTemplate: false,
  successPostTemplate: false,
  errorPostTemplate: false,

  putingTemplate: false,
  successPutTemplate: false,
  errorPutTemplate: false,

  deletingTemplateConector: false,
  successDeleteTemplateConector: false,
  errorDeleteTemplateConector: false,
});

const handleGetTemplates = (state, action) => {
  return state.set('loadingTemplates', false).set('successTemplates', false).set('errorTemplates', false);
};

const handleGetTemplatesSuccess = (state, action) => {
  const templates = action.data;

  return state.set('templates', List(templates)).set('loadingTemplates', false).set('successTemplates', true).set('errorTemplates', false);
};

const handleGetTemplatesError = (state, action) => {
  return state.set('loadingTemplates', false).set('successTemplates', false).set('errorTemplates', action.error);
};

const handleGetTemplate = (state, action) => {
  return state.set('loadingTemplate', false).set('successTemplate', false).set('errorTemplate', false);
};

const handleGetTemplateSuccess = (state, action) => {
  return state.set('template', action.data).set('loadingTemplate', false).set('successTemplate', true).set('errorTemplate', false);
};

const handleGetTemplateError = (state, action) => {
  return state.set('loadingTemplate', false).set('successTemplate', false).set('errorTemplate', action.error);
};

const handleGetTemplateConectores = (state, action) => {
  return state.set('loadingTemplateConectores', false).set('successTemplateConectores', false).set('errorTemplateConectores', false);
};

const handleGetTemplateConectoresSuccess = (state, action) => {
  return state
    .set('templateConectores', action.data)
    .set('loadingTemplateConectores', false)
    .set('successTemplateConectores', true)
    .set('errorTemplateConectores', false);
};

const handleGetTemplateConectoresError = (state, action) => {
  return state.set('loadingTemplateConectores', false).set('successTemplateConectores', false).set('errorTemplateConectores', action.error);
};

const handleGetTemplatesGrupos = (state, action) => {
  return state.set('loadingTemplatesGrupos', false).set('successTemplatesGrupos', false).set('errorTemplatesGrupos', false);
};

const handleGetTemplatesGruposSuccess = (state, action) => {
  return state
    .set('templatesGrupos', action.data)
    .set('loadingTemplatesGrupos', false)
    .set('successTemplatesGrupos', true)
    .set('errorTemplatesGrupos', false);
};

const handleGetTemplatesGruposError = (state, action) => {
  return state.set('loadingTemplatesGrupos', false).set('successTemplatesGrupos', false).set('errorTemplatesGrupos', action.error);
};

const handlePostTemplate = (state, action) => {
  return state.set('postingTemplate', true).set('successPostTemplate', false).set('errorPostTemplate', false);
};

const handlePostTemplateSuccess = (state, action) => {
  return state.set('postingTemplate', false).set('successPostTemplate', true).set('errorPostTemplate', false);
};

const handlePostTemplateError = (state, action) => {
  return state.set('postingTemplate', false).set('successPostTemplate', false).set('errorPostTemplate', action.error);
};

const handlePutTemplate = (state, action) => {
  return state.set('putingTemplate', true).set('successPutTemplate', false).set('errorPutTemplate', false);
};

const handlePutTemplateSuccess = (state, action) => {
  return state.set('putingTemplate', false).set('successPutTemplate', true).set('errorPutTemplate', false);
};

const handlePutTemplateError = (state, action) => {
  return state.set('putingTemplate', false).set('successPutTemplate', false).set('errorPutTemplate', action.error);
};

const handleDeleteTemplateConector = (state, action) => {
  return state.set('deletingTemplateConector', false).set('successDeleteTemplateConector', false).set('errorDeleteTemplateConector', false);
};

const handleDeleteTemplateConectorSuccess = (state, action) => {
  return state.set('deletingTemplateConector', false).set('successDeleteTemplateConector', true).set('errorDeleteTemplateConector', false);
};

const handleDeleteTemplateConectorError = (state, action) => {
  return state
    .set('deletingTemplateConector', false)
    .set('successDeleteTemplateConector', false)
    .set('errorDeleteTemplateConector', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_TEMPLATES:
      return handleGetTemplates(state, action);
    case Types.GET_TEMPLATES_SUCCESS:
      return handleGetTemplatesSuccess(state, action);
    case Types.GET_TEMPLATES_ERROR:
      return handleGetTemplatesError(state, action);

    case Types.GET_TEMPLATE:
      return handleGetTemplate(state, action);
    case Types.GET_TEMPLATE_SUCCESS:
      return handleGetTemplateSuccess(state, action);
    case Types.GET_TEMPLATE_ERROR:
      return handleGetTemplateError(state, action);

    case Types.GET_TEMPLATE_CONECTORES:
      return handleGetTemplateConectores(state, action);
    case Types.GET_TEMPLATE_CONECTORES_SUCCESS:
      return handleGetTemplateConectoresSuccess(state, action);
    case Types.GET_TEMPLATE_CONECTORES_ERROR:
      return handleGetTemplateConectoresError(state, action);

    case Types.GET_TEMPLATE_GRUPOS:
      return handleGetTemplatesGrupos(state, action);
    case Types.GET_TEMPLATE_GRUPOS_SUCCESS:
      return handleGetTemplatesGruposSuccess(state, action);
    case Types.GET_TEMPLATE_GRUPOS_ERROR:
      return handleGetTemplatesGruposError(state, action);

    case Types.POST_TEMPLATE:
      return handlePostTemplate(state, action);
    case Types.POST_TEMPLATE_SUCCESS:
      return handlePostTemplateSuccess(state, action);
    case Types.POST_TEMPLATE_ERROR:
      return handlePostTemplateError(state, action);

    case Types.PUT_TEMPLATE:
      return handlePutTemplate(state, action);
    case Types.PUT_TEMPLATE_SUCCESS:
      return handlePutTemplateSuccess(state, action);
    case Types.PUT_TEMPLATE_ERROR:
      return handlePutTemplateError(state, action);

    case Types.DELETE_TEMPLATE_CONECTORES:
      return handleDeleteTemplateConector(state, action);
    case Types.DELETE_TEMPLATE_CONECTORES_SUCCESS:
      return handleDeleteTemplateConectorSuccess(state, action);
    case Types.DELETE_TEMPLATE_CONECTORES_ERROR:
      return handleDeleteTemplateConectorError(state, action);

    case Types.RESET_TEMPLATES:
      return handleReset(state, action);

    default:
      return state;
  }
}
